module.exports = __webpack_public_path__ + "img/solution-hil-components.54f15b08.png";